import React from 'react';

const ImageSectionPage = ({ imageUrl, sectionText, onImageUrlChange, onSectionTextChange }) => {
    return (
        <div>
            <input
                type="text"
                placeholder="URL de la Imagen"
                value={imageUrl}
                onChange={(e) => onImageUrlChange(e.target.value)}
            />
            {imageUrl && <img src={imageUrl} alt="Preview" />}
            <textarea
                placeholder="Texto de la Sección"
                value={sectionText}
                onChange={(e) => onSectionTextChange(e.target.value)}
            />
        </div>
    );
};

export default ImageSectionPage;
